import React from "react";
import "./message-state.scss";
import Growbot from "../growbot/growbot";

interface IMessageStateProps {
  title: string;
  message: string;
}

function MessageState({ title, message }: IMessageStateProps) {
  return (
    <div className="no-cards-container">
      <div className="speech-bubble">
        <h2>{title}</h2>
        <p>{message}</p>
      </div>
      <Growbot botstyle="leaf" className="center" />
    </div>
  );
}

export default MessageState;
